import React, { memo } from 'react';
import { Timer } from './timer';
import { Result } from './result';

export const TimerAndResult = memo(({ isShowTimer }) => {
  return <div className='dr-wheel-center-small-circle'>{isShowTimer ? <Timer /> : <Result />}</div>;
});
